import { forwardRef } from 'react';
import { PracticasAutocomplete } from './PracticasAutocomplete';
import { FILTER_BY_MAP, usePracticas } from './hooks/usePracticas';

export const PracticasPorRolAutocomplete = forwardRef(
  ({ value, error, onChangeEvent, codigoSubtipoPractica, ...props }, ref) => {
    const { loading, options } = usePracticas({
      filterByAPI: FILTER_BY_MAP['byOrdenesPracticas'],
      filterByCodigoSubtipoPractica: codigoSubtipoPractica,
    });

    const properties = {
      ...props,
      value,
      error,
      loading,
      options,
      onChangeEvent,
    };

    return <PracticasAutocomplete {...properties} />;
  },
);

export default PracticasPorRolAutocomplete;
